import type { AdminMonitoringScopeFilter } from './api'

import { queryOptions } from '@tanstack/react-query'
import {
  getAdminMonitoringSummary,
  listAdminMonitoringFixtures,
  listAdminMonitoringUnavailable,
} from './api'

export const adminMonitoringQueryKeys = {
  all: ['admin-monitoring'] as const,
  summary: (filter: AdminMonitoringScopeFilter = {}) => [...adminMonitoringQueryKeys.all, 'summary', filter] as const,
  fixtures: (filter: AdminMonitoringScopeFilter = {}) => [...adminMonitoringQueryKeys.all, 'fixtures', filter] as const,
  unavailable: (filter: AdminMonitoringScopeFilter = {}) => [...adminMonitoringQueryKeys.all, 'unavailable', filter] as const,
}

export function adminMonitoringSummaryQueryOptions(filter: AdminMonitoringScopeFilter = {}) {
  return queryOptions({
    queryKey: adminMonitoringQueryKeys.summary(filter),
    queryFn: () => getAdminMonitoringSummary(filter),
  })
}

export function adminMonitoringFixturesQueryOptions(filter: AdminMonitoringScopeFilter = {}) {
  const query = { ...filter, limit: 50 }
  return queryOptions({
    queryKey: adminMonitoringQueryKeys.fixtures(filter),
    queryFn: () => listAdminMonitoringFixtures(query),
  })
}

export function adminMonitoringUnavailableQueryOptions(filter: AdminMonitoringScopeFilter = {}) {
  const query = { ...filter, limit: 50 }
  return queryOptions({
    queryKey: adminMonitoringQueryKeys.unavailable(filter),
    queryFn: () => listAdminMonitoringUnavailable(query),
  })
}
